var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 573,
    viewBox: "0 0 590 573",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1671_6258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0069 110.923L61.1429 525.863C62.0375 535.113 69.8104 542.17 79.1028 542.17H550.63C560.849 542.17 569.029 533.691 568.662 523.478L554.605 132.138C554.268 122.761 546.8 115.207 537.427 114.762L39.8216 91.1624C28.8395 90.6415 19.9484 99.9797 21.0069 110.923Z",
    fill: "#9DADCD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1671_6258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.429 308.504H233.549C229.705 308.492 225.995 307.091 223.103 304.559L153.542 243.208C151.154 241.099 148.077 239.936 144.891 239.938H84.8594V32.8861C84.8638 28.9394 86.4336 25.1557 89.2243 22.365C92.015 19.5742 95.7988 18.0045 99.7454 18H387.543C391.489 18.0045 395.273 19.5742 398.064 22.365C400.854 25.1557 402.424 28.9394 402.429 32.8861L402.429 308.504Z",
    fill: "#F3F5FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.489 123.556H139.818C138.163 123.554 136.577 122.979 135.407 121.957C134.237 120.935 133.579 119.548 133.577 118.103V65.8556C133.579 64.4098 134.237 63.0237 135.407 62.0014C136.577 60.9792 138.163 60.4042 139.818 60.4026H190.489C192.144 60.4042 193.73 60.9792 194.9 62.0014C196.07 63.0237 196.728 64.4098 196.73 65.8556V118.103C196.728 119.548 196.07 120.935 194.9 121.957C193.73 122.979 192.144 123.554 190.489 123.556Z",
    fill: "#7B99CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.574 65.5903H217.932C216.855 65.5903 215.823 66.018 215.061 66.7794C214.3 67.5407 213.872 68.5734 213.872 69.6501C213.872 70.7268 214.3 71.7595 215.061 72.5208C215.823 73.2822 216.855 73.7099 217.932 73.7099H276.574C277.651 73.7099 278.683 73.2822 279.445 72.5208C280.206 71.7595 280.634 70.7268 280.634 69.6501C280.634 68.5734 280.206 67.5407 279.445 66.7794C278.683 66.018 277.651 65.5903 276.574 65.5903Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.704 91.3026H217.156C215.343 91.3026 213.872 93.125 213.872 95.3624C213.872 97.5998 215.343 99.4222 217.156 99.4222H361.704C363.518 99.4222 364.988 97.5998 364.988 95.3624C364.988 93.125 363.518 91.3026 361.704 91.3026Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.346 145.659H136.943C135.211 145.659 133.804 147.482 133.804 149.719C133.804 151.956 135.211 153.779 136.943 153.779H350.346C352.078 153.779 353.486 151.956 353.486 149.719C353.486 147.482 352.078 145.659 350.346 145.659Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.346 170.92H136.943C135.211 170.92 133.804 172.743 133.804 174.98C133.804 177.218 135.211 179.04 136.943 179.04H350.346C352.078 179.04 353.486 177.218 353.486 174.98C353.486 172.743 352.078 170.92 350.346 170.92Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.346 196.182H136.943C135.211 196.182 133.804 198.004 133.804 200.241C133.804 202.479 135.211 204.301 136.943 204.301H350.346C352.078 204.301 353.486 202.479 353.486 200.241C353.486 198.004 352.078 196.182 350.346 196.182Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.346 221.443H136.943C135.211 221.443 133.804 223.265 133.804 225.503C133.804 227.74 135.211 229.563 136.943 229.563H350.346C352.078 229.563 353.486 227.74 353.486 225.503C353.486 223.265 352.078 221.443 350.346 221.443Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddd_1671_6258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542.268 291.362H233.549C230.475 291.368 227.468 290.469 224.901 288.779L224.698 288.646V77.9953C224.703 74.0487 226.272 70.2649 229.063 67.4742C231.854 64.6835 235.638 63.1137 239.584 63.1093H527.382C531.328 63.1137 535.112 64.6835 537.903 67.4742C540.693 70.2649 542.263 74.0487 542.268 77.9953L542.268 291.362Z",
    fill: "#F1F4F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.525 174.98H277.853C276.198 174.979 274.612 174.404 273.442 173.381C272.272 172.359 271.614 170.973 271.612 169.527V117.28C271.614 115.834 272.272 114.448 273.442 113.426C274.612 112.404 276.198 111.829 277.853 111.827H328.525C330.179 111.829 331.765 112.404 332.935 113.426C334.105 114.448 334.764 115.834 334.765 117.28V169.527C334.764 170.973 334.105 172.359 332.935 173.381C331.765 174.404 330.179 174.979 328.525 174.98Z",
    fill: "#7B99CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.413 120.624H357.771C356.694 120.624 355.661 121.051 354.9 121.813C354.139 122.574 353.711 123.607 353.711 124.683C353.711 125.76 354.139 126.793 354.9 127.554C355.661 128.316 356.694 128.743 357.771 128.743H416.413C417.49 128.743 418.522 128.316 419.284 127.554C420.045 126.793 420.473 125.76 420.473 124.683C420.473 123.607 420.045 122.574 419.284 121.813C418.522 121.051 417.49 120.624 416.413 120.624Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.543 142.727H356.995C355.181 142.727 353.711 144.55 353.711 146.787C353.711 149.024 355.181 150.847 356.995 150.847H501.543C503.357 150.847 504.827 149.024 504.827 146.787C504.827 144.55 503.357 142.727 501.543 142.727Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.184 190.769H276.781C275.049 190.769 273.642 192.591 273.642 194.828C273.642 197.066 275.049 198.888 276.781 198.888H490.184C491.916 198.888 493.324 197.066 493.324 194.828C493.324 192.591 491.916 190.769 490.184 190.769Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.184 212.421H276.781C275.049 212.421 273.642 214.243 273.642 216.481C273.642 218.718 275.049 220.541 276.781 220.541H490.184C491.916 220.541 493.324 218.718 493.324 216.481C493.324 214.243 491.916 212.421 490.184 212.421Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.184 237.682H276.781C275.049 237.682 273.642 239.505 273.642 241.742C273.642 243.979 275.049 245.802 276.781 245.802H490.184C491.916 245.802 493.324 243.979 493.324 241.742C493.324 239.505 491.916 237.682 490.184 237.682Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.184 262.943H276.781C275.049 262.943 273.642 264.766 273.642 267.003C273.642 269.241 275.049 271.063 276.781 271.063H490.184C491.916 271.063 493.324 269.241 493.324 267.003C493.324 264.766 491.916 262.943 490.184 262.943Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.844 163.252H542.245C552.21 163.252 560.301 171.196 560.427 181.16C561.53 268.786 568.869 520.296 568.859 545.327C568.859 547.583 71.7625 549.999 61.8308 545.327C57.9949 543.523 57.3199 242.644 61.8308 231.818C66.3418 220.992 378.047 232.269 392.482 231.818C403.171 231.484 444.312 192.479 467.903 168.671C471.33 165.212 475.974 163.252 480.844 163.252Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1671_6258)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.193,
    y: 359.352,
    width: 154.743,
    height: 89.8761,
    rx: 3.13989,
    fill: "#BADEF3",
    stroke: "#689AFF",
    strokeWidth: 3.13989
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.936 423.26H325.19C323.762 420.2 320.906 412.734 320.906 407.349C320.906 400.618 334.369 384.707 314.174 384.707C293.368 384.707 304.995 402.453 306.831 407.349C308.3 411.265 304.179 419.588 301.936 423.26Z",
    fill: "#689AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.763 431.963H390.047V444.522C390.047 446.257 388.642 447.662 386.907 447.662H240.903C239.168 447.662 237.763 446.257 237.763 444.522V431.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.047 375.445H237.762V362.886C237.762 361.152 239.168 359.746 240.902 359.746H386.907C388.641 359.746 390.047 361.152 390.047 362.886V375.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.658 322.299C359.069 331.709 364.356 344.473 364.356 357.781H353.34C353.34 347.394 349.214 337.433 341.869 330.088C334.524 322.744 324.563 318.617 314.176 318.617C303.789 318.617 293.827 322.744 286.482 330.088C279.137 337.433 275.011 347.394 275.011 357.781H263.996C263.996 344.473 269.283 331.709 278.693 322.299C288.104 312.888 300.867 307.602 314.176 307.602C327.484 307.602 340.248 312.888 349.658 322.299Z",
    fill: "#689AFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1671_6258",
    x: 0.170628,
    y: 0.858472,
    width: 589.439,
    height: 571.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.60874
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3751
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780937 0 0 0 0 0.853029 0 0 0 0 0.991667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6258"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1671_6258",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1671_6258",
    x: 80.3484,
    y: 13.4891,
    width: 326.591,
    height: 299.526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25546
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6258"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1671_6258",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_1671_6258",
    x: 220.187,
    y: 59.5005,
    width: 326.591,
    height: 238.177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.80437
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.80437
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6258"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.70656
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.80437
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1671_6258",
    result: "effect2_dropShadow_1671_6258"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.902186
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25546
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1671_6258",
    result: "effect3_dropShadow_1671_6258"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1671_6258",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1671_6258",
    x: 226.668,
    y: 307.602,
    width: 173.793,
    height: 159.107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.95532
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.97766
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.575799 0 0 0 0 0.639705 0 0 0 0 0.858333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1671_6258"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1671_6258",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollector);
export default __webpack_public_path__ + "static/media/collector.c89bc3162ec93008136f4d251e0fda95.svg";
export { ForwardRef as ReactComponent };